import * as queryString from 'querystring';
import addSeconds from 'owa-date-utc-fn/lib/addSeconds';
import TokenResponse from 'owa-service/lib/contract/TokenResponse';
import TokenResponseCode from 'owa-service/lib/contract/TokenResponseCode';

export interface Options {
    client_id: string;
    scope: string;
    redirect_uri: string;
    authorization_uri: string;
}

let eventListners = {};

export async function fetchDelegationAccessTokenFromMsa(opts: Options): Promise<TokenResponse> {
    let cacheKey = opts.client_id + opts.scope;
    let iframeId = encodeURIComponent(cacheKey);
    let tokenResponse: TokenResponse = {};
    try {
        tokenResponse = await internalFetchDelegationAccessTokenFromMsa(opts, window);
    } catch (exception) {
        tokenResponse.TokenResultCode = TokenResponseCode.Failed;
    } finally {
        cleanUpIframe(iframeId, window);
    }
    return tokenResponse;
}

async function internalFetchDelegationAccessTokenFromMsa(
    opts: Options,
    parentWindow: Window
): Promise<TokenResponse> {
    let iframeId = encodeURIComponent(opts.client_id + opts.scope);
    let url = getAuthenticationUrl(opts);
    if (!parentWindow.document.getElementById(iframeId)) {
        const iframe = parentWindow.document.createElement('iframe');
        iframe.src = url.toString();
        iframe.style.display = 'none';
        iframe.id = iframeId;
        parentWindow.document.body.appendChild(iframe);
        return new Promise((resolve, reject) => {
            eventListners[iframeId] = function(e: any) {
                let tokenResponse: TokenResponse = {};
                try {
                    if (
                        iframe.contentWindow &&
                        iframe.contentWindow.location.origin == parentWindow.location.origin
                    ) {
                        tokenResponse = ParseHashParam(
                            iframe.contentWindow.location.hash.substring(1)
                        );
                    }
                } catch (err) {
                    tokenResponse.TokenResultCode = TokenResponseCode.Failed;
                    reject(tokenResponse);
                }

                resolve(tokenResponse);
            };
            iframe.addEventListener('load', eventListners[iframeId], false);
        });
    }

    return { TokenResultCode: TokenResponseCode.Failed };
}

export function ParseHashParam(hashParam: string): TokenResponse {
    let params = queryString.parse(hashParam);
    let tokenResponse: TokenResponse = {};
    if (params.access_token) {
        tokenResponse.AccessToken = params.access_token;
        tokenResponse.AccessTokenExpiry = addSeconds(
            Date.now(),
            parseInt(params.expires_in)
        ).toISOString();
        tokenResponse.TokenResultCode = TokenResponseCode.Success;
    } else if (
        params.error == 'login_required' ||
        params.error == 'interaction_required' ||
        params.error == 'consent_required'
    ) {
        tokenResponse.TokenResultCode = TokenResponseCode.Unauthorized;
    } else {
        tokenResponse.TokenResultCode = TokenResponseCode.Failed;
    }

    return tokenResponse;
}

function cleanUpIframe(id: string, window: Window) {
    var element = window.document.getElementById(id);
    if (element != null) {
        element.removeEventListener('load', eventListners[id]);
        window.document.body.removeChild(element);
        delete eventListners[id];
    }
}

export function getAuthenticationUrl(opts: Options): string {
    let queryParams = {
        response_type: 'token',
        prompt: 'none', // silent auth, don't prompt the user
        redirect_uri: opts.redirect_uri,
        scope: opts.scope,
        client_id: opts.client_id,
    };

    return opts.authorization_uri + '?' + queryString.stringify(queryParams);
}
